import { FC } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type Props = {
  onSelect: (value: string) => void;
  dateSelection: string
};

export const DateFilter: FC<Props> = ({ onSelect, dateSelection }) => {
  const dateValue = dateSelection ? new Date(dateSelection) : new Date()
  return (
    <DatePicker selected={dateValue} onChange={(date) => onSelect(date!.toUTCString())} />
  );
};
